import { ApplicationConfigWithPages } from '../../../shared/features/ng-redux/app/appConfig.models';
import { ChartOption, PageConfigWithCharts } from '../../../shared/features/ng-redux/page/page.models';
import { CardConfig, DashboardElement } from '../../../shared/models/chart.models';

export function patchCard<T>(charts: DashboardElement[], chartId: string, replacement: (card: CardConfig & T) => void) {
  if (!charts) {
    throw new Error(`Could not match card to patch - ${chartId}`);
  }
  const card = <CardConfig & T>charts.find(chart => chart.baselineId === chartId);
  if (card) {
    replacement(card);
  } else {
    console.error(`Could not match card to patch - ${chartId}`);
  }
}

export function patchChart<T>(charts: DashboardElement[], chartId: string, replacement: (chart: T) => void) {
  if (!charts) {
    throw new Error(`Could not match chart to patch - ${chartId}`);
  }
  const chart = <T>(<unknown>charts.find(_chart => _chart.baselineId === chartId));
  if (chart) {
    replacement(chart);
  } else {
    console.error(`Could not match chart to patch - ${chartId}`);
  }
}

export function patchPage(
  app: ApplicationConfigWithPages,
  baselineId: string,
  patchFn: (page: PageConfigWithCharts) => void
) {
  if (!app || !app.pages) {
    throw new Error(`Could not match page to patch - ${baselineId}`);
  }
  const page: PageConfigWithCharts = app.pages.find(p => p.baselineId === baselineId);
  if (!page) {
    console.error(`Could not match page to patch - ${baselineId}`);
  } else {
    patchFn(page);
  }
}

export function buildChartOptions(
  charts: CardConfig[],
  baselineId: string,
  name: string,
  tooltip?: string
): ChartOption {
  const chart = charts.find(c => c.baselineId === baselineId);

  return {
    isSelected: true,
    name: name,
    chartId: chart ? chart.id : '', //TODO Revert after completion of 4459
    tooltip: tooltip,
  };
}

export function findPageId(pages: PageConfigWithCharts[], baselineId: string): string {
  if (!pages) {
    throw new Error(`Could not match page for ${baselineId}`);
  }
  const page = pages.find(p => p.baselineId === baselineId);
  if (!page) {
    console.log(
      'Page not matched',
      baselineId,
      pages.map(p => ({ baselineId: p.baselineId, id: p.id }))
    );
    return undefined;
  }
  return page.id;
}
